(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tpl-campaign-hub"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const init=()=>document.querySelectorAll('[data-tpl-campaign-hub]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const tabs=[...root.querySelectorAll('[data-tpl-campaign-tab]')],panels=[...root.querySelectorAll('[data-tpl-campaign-panel]')];
  if(tabs.length!==panels.length)return;
  tabs[0].parentElement.setAttribute('role','tablist');
  const show=index=>tabs.forEach((tab,i)=>{tab.id='TplCampaignTab-'+i;tab.setAttribute('role','tab');tab.setAttribute('aria-controls',panels[i].id);tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;if(i===index)tab.setAttribute('aria-current','page');else tab.removeAttribute('aria-current');panels[i].hidden=i!==index;panels[i].setAttribute('role','tabpanel');panels[i].setAttribute('aria-labelledby',tab.id);});
  const fromHash=()=>{
   const all=location.hash==='#TplAllFilms';
   root.classList.toggle('is-film-index',all);
   root.querySelector('[data-tpl-film-selected-title]').hidden=all;
   root.querySelector('[data-tpl-film-all-title]').hidden=!all;
   show(all||location.hash==='#TplCampaignFilms'?2:location.hash.startsWith('#Archive--')||location.hash==='#TplArchiveCollections'||(!location.hash&&root.dataset.archiveRoute==='true')?1:0);
  };
  const filmDialog=root.querySelector('.tpl-film-dialog'),player=filmDialog.querySelector('.tpl-film-player'),external=filmDialog.querySelector('[data-tpl-film-external]');
  let filmOpener;
  root.querySelectorAll('[data-tpl-film]').forEach(button=>button.addEventListener('click',event=>{
   event.preventDefault();
   filmOpener=button;filmDialog.querySelector('h2').textContent=button.dataset.filmTitle;player.replaceChildren();external.hidden=true;external.removeAttribute('href');
   const host=button.dataset.filmHost,id=button.dataset.filmId;
   if(host==='shopify'){
    const template=document.getElementById(button.dataset.filmTemplate);if(!template)return;
    player.append(template.content.cloneNode(true));
   }else if(host==='mp4'){
    const url=button.dataset.filmUrl;if(!url)return;
    const video=document.createElement('video');video.controls=true;video.playsInline=true;video.preload='metadata';
    video.setAttribute('aria-label',button.dataset.filmTitle);video.poster=button.dataset.filmPoster||button.querySelector('img')?.src||'';
    const source=document.createElement('source');source.src=url;source.type='video/mp4';video.append(source);
    const error=document.createElement('p');error.className='tpl-film-error';error.hidden=true;error.setAttribute('role','alert');error.textContent=filmDialog.dataset.filmError;
    video.addEventListener('error',()=>{error.hidden=false;});player.append(video,error);
   }else{
    if(!['vimeo','youtube'].includes(host)||!id)return;
    const iframe=document.createElement('iframe');iframe.title=button.dataset.filmTitle;iframe.allow='autoplay; fullscreen; picture-in-picture';iframe.allowFullscreen=true;
    iframe.src=host==='vimeo'?'https://player.vimeo.com/video/'+encodeURIComponent(id)+'?autoplay=1&dnt=1':'https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1';player.append(iframe);
    external.href=host==='vimeo'?'https://vimeo.com/'+encodeURIComponent(id):'https://www.youtube.com/watch?v='+encodeURIComponent(id);external.hidden=false;
   }
   filmDialog.showModal();const video=player.querySelector('video');if(video)video.play().catch(()=>{});
  }));
  filmDialog.querySelector('[data-tpl-film-close]').addEventListener('click',()=>filmDialog.close());
  filmDialog.addEventListener('close',()=>{const video=player.querySelector('video');if(video){video.pause();video.removeAttribute('src');video.querySelectorAll('source').forEach(source=>source.remove());video.load();}player.replaceChildren();filmOpener?.focus({preventScroll:true});});
  fromHash();window.addEventListener('hashchange',()=>{fromHash();const target=document.getElementById(location.hash.slice(1));if(target&&root.contains(target))requestAnimationFrame(()=>target.scrollIntoView({block:'start',behavior:'auto'}));});
  root.querySelector('[data-tpl-film-view-all]')?.addEventListener('click',event=>{
   event.preventDefault();history.pushState(history.state,'','#TplAllFilms');fromHash();
   const heading=root.querySelector('#TplAllFilms');heading.focus({preventScroll:true});heading.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
  });
  tabs.forEach((tab,index)=>{tab.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();history.replaceState(history.state,'',tab.hash);fromHash();});tab.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?tabs.length-1:(index+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;history.replaceState(history.state,'',tabs[next].hash);fromHash();tabs[next].focus({preventScroll:true});});});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-checkout-entry"]) return;
  try {
    
(() => {
  const form = document.getElementById('TplCheckoutEmail');
  if (!form) return;
  const email = form.querySelector('input[type=email]');
  const error = form.querySelector('[role=alert]');
  const button = form.querySelector('button[type=submit]');
  form.noValidate = true;
  form.addEventListener('submit', event => {
    email.value = email.value.trim();
    if (!email.validity.valid) {
      event.preventDefault();
      error.textContent = email.value ? form.dataset.errorInvalid : form.dataset.errorEmpty;
      error.hidden = false;
      email.setAttribute('aria-invalid', 'true');
      email.focus();
      return;
    }
    if (button.getAttribute('aria-busy') === 'true') { event.preventDefault(); return; }
    button.setAttribute('aria-busy', 'true');
  });
  email.addEventListener('input', () => { error.hidden = true; email.removeAttribute('aria-invalid'); });
  window.addEventListener('pageshow', () => button.removeAttribute('aria-busy'));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-club-collection"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('tpl-archive')){customElements.define('tpl-archive',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.tpl-archive__track'),slides=[...track.children],prev=this.querySelector('[data-archive-prev]'),next=this.querySelector('[data-archive-next]'),count=this.querySelector('.tpl-archive__count');let index=0;const update=()=>{const x=track.scrollLeft;index=slides.reduce((best,slide,i)=>Math.abs(slide.offsetLeft-slides[0].offsetLeft-x)<Math.abs(slides[best].offsetLeft-slides[0].offsetLeft-x)?i:best,0);const atEnd=x>=track.scrollWidth-track.clientWidth-3;count.textContent=String(atEnd?slides.length:index+1).padStart(2,'0')+' / '+slides.length;prev.disabled=x<2;next.disabled=x>=track.scrollWidth-track.clientWidth-3;};const move=delta=>{const target=Math.max(0,Math.min(slides.length-1,index+delta));track.scrollTo({left:slides[target].offsetLeft-slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});track.addEventListener('scroll',()=>requestAnimationFrame(update),{passive:true});this.resize=new ResizeObserver(update);this.resize.observe(track);update();}disconnectedCallback(){this.resize?.disconnect();this.ready=false;}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-fashion-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tpl-journal')) {
  customElements.define('tpl-journal', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.tpl-home-journal__rail');
      this.previous = this.querySelector('[data-journal-prev]');
      this.next = this.querySelector('[data-journal-next]');
      if (!this.rail || !this.previous || !this.next) return;
      this.previous.hidden = this.next.hidden = false;
      this.update = () => {
        this.previous.disabled = this.rail.scrollLeft < 2;
        this.next.disabled = this.rail.scrollLeft >= this.rail.scrollWidth - this.rail.clientWidth - 2;
      };
      this.move = direction => {
        const card = this.rail.querySelector('.tpl-home-journal__post');
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.rail).gap) : this.rail.clientWidth;
        this.rail.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.onClick = event => {
        if (event.target.closest('[data-journal-prev]')) this.move(-1);
        if (event.target.closest('[data-journal-next]')) this.move(1);
      };
      this.onKey = event => {
        if (event.target !== this.rail || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.rail.scrollTo({left:event.key === 'Home' ? 0 : this.rail.scrollWidth,behavior:'instant'});
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      };
      this.addEventListener('click',this.onClick);
      this.rail.addEventListener('keydown',this.onKey);
      this.rail.addEventListener('scroll',this.update,{passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.rail);
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('click',this.onClick);
      this.rail?.removeEventListener('keydown',this.onKey);
      this.rail?.removeEventListener('scroll',this.update);
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-footwear-classic"] && !Shopify.designMode) return;
  try {
    
(() => {
  const setup = (article) => {
    if (article.dataset.tplReadingReady === 'true') return;
    const payload = article.querySelector('[data-tpl-reading-copy]');
    const selector = article.querySelector('[data-tpl-reading-selector]');
    if (!payload || !selector) return;
    let data;
    try { data = JSON.parse(payload.textContent); } catch { return; }
    const languages = ['en', 'fr', 'es', 'ja'];
    if (!Array.isArray(data.entries) || data.entries.length < 50 ||
      !data.entries.every(entry => languages.every(lang => typeof entry[lang] === 'string' && entry[lang].length))) return;
    const base = article.dataset.tplReadingBase === 'fr' ? 'fr' : 'en';
    const lookup = new Map(data.entries.map(entry => [entry[base], entry]));
    const records = [];
    const walker = document.createTreeWalker(article, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement.closest('script, style, [data-tpl-reading-selector]')) continue;
      const original = node.nodeValue;
      const key = original.trim();
      const entry = lookup.get(key);
      if (entry) records.push({ node, entry, before: original.slice(0, original.indexOf(key)), after: original.slice(original.indexOf(key) + key.length) });
    }
    const attributes = [];
    article.querySelectorAll('[alt], [aria-label]').forEach(node => {
      if (node.closest('[data-tpl-reading-selector]')) return;
      ['alt', 'aria-label'].forEach(name => {
        const entry = lookup.get(node.getAttribute(name));
        if (entry) attributes.push({ node, name, entry });
      });
    });
    if (records.length < 50 || attributes.length < 4) return;
    const label = selector.querySelector('[data-tpl-reading-label]');
    const note = selector.querySelector('[data-tpl-reading-note]');
    const controls = [...selector.querySelectorAll('[data-tpl-reading-lang]')];
    const apply = (requested) => {
      const lang = languages.includes(requested) ? requested : base;
      records.forEach(({ node, entry, before, after }) => { node.nodeValue = before + entry[lang] + after; });
      attributes.forEach(({ node, name, entry }) => node.setAttribute(name, entry[lang]));
      article.lang = lang;
      selector.lang = lang;
      selector.setAttribute('aria-label', data.interface[lang].choose);
      label.textContent = data.interface[lang].label;
      note.textContent = data.interface[lang].note;
      controls.forEach(control => {
        const selected = control.dataset.tplReadingLang === lang;
        if (control.tagName === 'BUTTON') control.setAttribute('aria-pressed', String(selected));
        else if (selected) control.setAttribute('aria-current', 'true');
        else control.removeAttribute('aria-current');
      });
      article.dataset.tplReadingLanguage = lang;
    };
    selector.addEventListener('click', event => {
      const button = event.target.closest('button[data-tpl-reading-lang]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      const lang = button.dataset.tplReadingLang;
      const url = new URL(window.location.href);
      if (lang === 'en' || lang === 'fr') {
        url.searchParams.delete('reading');
        if (lang === base) {
          apply(lang);
          window.history.pushState(null, '', url);
          return;
        }
        const destination = (lang === 'fr' ? '/fr' : '') + '/pages/the-saturday-afternoon-man-shoe';
        const form = document.getElementById('TplCityLocalization');
        if (form?.elements.language_code && form.elements.return_to) {
          form.elements.language_code.value = lang;
          form.elements.return_to.value = destination;
          form.requestSubmit();
        } else window.location.assign(destination);
        return;
      }
      apply(lang);
      url.searchParams.set('reading', lang);
      if (url.href !== window.location.href) window.history.pushState(null, '', url);
    });
    const readSelection = () => {
      const lang = new URL(window.location.href).searchParams.get('reading');
      apply(lang === 'es' || lang === 'ja' ? lang : base);
    };
    window.addEventListener('popstate', readSelection);
    article.dataset.tplReadingReady = 'true';
    readSelection();
    selector.hidden = false;
  };
  const initialize = () => document.querySelectorAll('.tpl-classic--saturday[data-tpl-reading-base]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-made-for-club"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initProject = () => {
    const sport = new URLSearchParams(location.search).get('sport');
    if (!['soccer','tennis','basketball','baseball'].includes(sport)) return;
    document.querySelectorAll('[data-mfc-project-sport]').forEach(select => { if (!select.value) select.value = sport; });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProject, {once:true});
  else initProject();
  document.addEventListener('shopify:section:load', initProject);
})();

(() => {
  const init = () => document.querySelectorAll('[data-tpl-club-sports]').forEach(nav => {
    if (nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    const notices = nav.querySelectorAll('.tpl-club-sports__notice');
    let timer;
    const clearNotices = () => notices.forEach(notice => {
      notice.classList.remove('is-visible');
      notice.textContent = '';
    });
    nav.querySelectorAll('[data-tpl-club-coming-soon]').forEach(button => {
      button.addEventListener('click', () => {
        clearTimeout(timer);
        clearNotices();
        const notice = button.parentElement.querySelector('.tpl-club-sports__notice');
        notice.textContent = 'Coming soon';
        notice.classList.add('is-visible');
        timer = setTimeout(clearNotices, 4000);
      });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

if (!customElements.get('tpl-detail-carousel')) {
  customElements.define('tpl-detail-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const track = this.querySelector('.tpl-partners__detail-track');
      const slides = [...this.querySelectorAll('.tpl-partners__detail-slide')];
      const previous = this.querySelector('[data-detail-prev]');
      const next = this.querySelector('[data-detail-next]');
      const current = this.querySelector('[data-detail-current]');
      const position = () => {
        const left = track.getBoundingClientRect().left;
        return slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? index : best, 0);
      };
      const update = () => {
        const index = position();
        current.textContent = String(index + 1).padStart(2, '0');
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
      };
      const move = (index) => {
        const target = slides[Math.max(0, Math.min(slides.length - 1, index))];
        track.scrollTo({ left: track.scrollLeft + target.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(position() - 1), options);
      next.addEventListener('click', () => move(position() + 1), options);
      track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : position() + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
      }, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-mobile-opening"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const link = event.target.closest('[data-tpl-opening-shop]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = document.getElementById('TplShopProducts');
  if (!target) return;
  event.preventDefault();
  const header = document.getElementById('TplStickyHeader');
  const offset = header ? header.getBoundingClientRect().height : 112;
  const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - offset - 8);
  target.focus({preventScroll:true});
  if (location.hash !== link.hash) history.pushState(history.state, '', link.hash);
  window.scrollTo({top, behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-press-media"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => document.querySelectorAll('[data-media-editorial]').forEach(root => {
    if (root.dataset.mediaReady) return;
    root.dataset.mediaReady = 'true';
    const dialog = root.querySelector('.tpl-media-viewer');
    if (!dialog) return;
    const image = dialog.querySelector('img');
    const caption = dialog.querySelector('[data-media-caption]');
    const count = dialog.querySelector('[data-media-count]');
    let photographs = [], index = 0;
    const show = () => {
      const photograph = photographs[index];
      if (!photograph) return;
      image.src = photograph.dataset.src;
      image.alt = photograph.dataset.caption;
      caption.textContent = photograph.dataset.caption;
      count.textContent = `${index + 1} / ${photographs.length}`;
    };
    const move = direction => { index = (index + direction + photographs.length) % photographs.length; show(); };
    root.addEventListener('click', event => {
      const photograph = event.target.closest('[data-media-photo]');
      if (photograph) {
        photographs = Array.from(photograph.closest('article').querySelectorAll('[data-media-photo]'));
        index = photographs.indexOf(photograph);
        show();
        dialog.showModal();
      }
      if (event.target.closest('[data-media-close]')) dialog.close();
      if (event.target.closest('[data-media-prev]')) move(-1);
      if (event.target.closest('[data-media-next]')) move(1);
      if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }
    });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); move(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); move(-1); }
    });
    dialog.addEventListener('close', () => image.removeAttribute('src'));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-proper-edit"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-proper-edit]').forEach(root => {
    if (root.dataset.viewerReady) return;
    root.dataset.viewerReady = 'true';
    const frames = [...root.querySelectorAll('[data-edit-frame]')];
    const dialog = root.querySelector('dialog');
    const image = dialog.querySelector('[data-viewer-image]');
    const previous = dialog.querySelector('[data-viewer-previous]');
    const next = dialog.querySelector('[data-viewer-next]');
    let current = 0, trigger = null;
    const show = index => {
      current = Math.max(0, Math.min(frames.length - 1, index));
      image.src = frames[current].dataset.fullImage;
      image.alt = frames[current].querySelector('img').alt;
      dialog.querySelector('[data-viewer-count]').textContent = frames[current].dataset.frameLabel;
      previous.disabled = current === 0;
      next.disabled = current === frames.length - 1;
    };
    frames.forEach((frame, index) => frame.addEventListener('click', () => {
      trigger = frame;
      show(index);
      dialog.showModal();
    }));
    previous.addEventListener('click', () => show(current - 1));
    next.addEventListener('click', () => show(current + 1));
    dialog.querySelector('[data-viewer-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(current - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); show(current + 1); }
    });
    dialog.addEventListener('close', () => trigger?.focus({preventScroll:true}));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-proper-sneaker"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tpl-sneaker-colourways')) {
  customElements.define('tpl-sneaker-colourways', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('[data-colourway-track]');
      const slides = Array.from(this.querySelectorAll('[data-colourway-slide]'));
      const options = Array.from(this.querySelectorAll('[data-colourway-index]'));
      const previous = this.querySelector('[data-colourway-previous]');
      const next = this.querySelector('[data-colourway-next]');
      const status = this.querySelector('[data-colourway-status]');
      let current = 0;
      const sync = () => {
        options.forEach((button, index) => button.setAttribute('aria-pressed', String(index === current)));
        previous.disabled = current === 0;
        next.disabled = current === slides.length - 1;
        status.textContent = `${current + 1} / ${slides.length}`;
        status.setAttribute('aria-label', `${slides[current].dataset.label}, ${current + 1} / ${slides.length}`);
      };
      const show = (index) => {
        current = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({left:current * track.clientWidth, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        sync();
      };
      options.forEach(button => button.addEventListener('click', () => show(Number(button.dataset.colourwayIndex))));
      previous.addEventListener('click', () => show(current - 1));
      next.addEventListener('click', () => show(current + 1));
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        show(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1));
      });
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== current && index >= 0 && index < slides.length) { current = index; sync(); }
      }, {passive:true});
      sync();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-sustainability-archive"] && !Shopify.designMode) return;
  try {
    
(()=>{
const init=()=>document.querySelectorAll('[data-sfa]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 root.querySelectorAll('[data-archive-gallery]').forEach(gallery=>{
  if(gallery.dataset.galleryReady)return;gallery.dataset.galleryReady='true';
  const source=gallery.querySelector('[data-archive-images]');if(!source)return;
  const images=JSON.parse(source.textContent),image=gallery.querySelector('img'),previous=gallery.querySelector('[data-archive-direction="-1"]'),next=gallery.querySelector('[data-archive-direction="1"]');let index=0,start=null;
  const show=step=>{index=Math.max(0,Math.min(images.length-1,index+step));image.src=images[index];image.srcset='';image.dataset.stillSrc=images[index];image.dataset.stillSrcset='';previous.disabled=index===0;next.disabled=index===images.length-1;gallery.dataset.imageIndex=String(index);};
  gallery.querySelectorAll('[data-archive-direction]').forEach(button=>button.addEventListener('click',event=>{event.preventDefault();event.stopPropagation();show(Number(button.dataset.archiveDirection))}));
  gallery.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(event.key==='ArrowLeft'?-1:1)}});
  gallery.addEventListener('pointerdown',event=>{if(!event.target.closest('button')&&event.pointerType!=='mouse')start={x:event.clientX,y:event.clientY}});
  gallery.addEventListener('pointerup',event=>{if(!start)return;const x=event.clientX-start.x,y=event.clientY-start.y;start=null;if(Math.abs(x)>40&&Math.abs(x)>Math.abs(y)*1.5)show(x<0?1:-1)});
  gallery.addEventListener('pointercancel',()=>{start=null});
 });
 const archiveNav=root.querySelector('.tpl-sfa__nav');
 if(archiveNav){const measure=()=>root.style.setProperty('--sfa-nav-height',`${Math.ceil(archiveNav.getBoundingClientRect().height)}px`);measure();if('ResizeObserver'in window)new ResizeObserver(measure).observe(archiveNav);else window.addEventListener('resize',measure,{passive:true});}
 const data=JSON.parse(root.querySelector('[data-sfa-library-data]').textContent),lang=root.dataset.language==='fr'?'fr':'en',labels=data.labels[lang];
 const pauseOthers=current=>root.querySelectorAll('video').forEach(video=>{if(video!==current)video.pause()});
 root.querySelectorAll('[data-sfa-video]').forEach(wrap=>{
  const video=wrap.querySelector('video'),select=wrap.querySelector('select'),sources=JSON.parse(wrap.dataset.sources);
  const assign=(format,keepTime=false)=>{const source=sources[format];if(!source)return;const time=keepTime?video.currentTime:0;video.pause();video.src=source.src;video.poster=source.poster;video.style.aspectRatio=format==='portrait'?'9/16':format==='square'?'1':'16/9';video.addEventListener('loadedmetadata',()=>{if(time)video.currentTime=Math.min(time,video.duration||time)},{once:true});video.load();select.value=format;};
  assign(sources.landscape?'landscape':sources.square?'square':'portrait');
  select.addEventListener('change',()=>assign(select.value,true));
 });
 root.querySelectorAll('video').forEach(video=>{video.playsInline=true;video.addEventListener('play',()=>pauseOthers(video));});
 const filters=[...root.querySelectorAll('[data-sfa-filter]')],grid=root.querySelector('[data-sfa-grid]'),viewer=root.querySelector('[data-sfa-viewer]'),more=root.querySelector('[data-sfa-more]'),count=root.querySelector('[data-sfa-count]');
 let category='campaign',limit=12,selected=null;
 const title=item=>item.title[lang]||item.title.en;
 const choose=(item,focus=false)=>{selected=item.id;const first=item.variants[0],img=viewer.querySelector('img');img.src=first.src;img.alt=title(item);viewer.querySelector('[data-sfa-caption]').textContent=title(item);viewer.querySelector('small').textContent=item.credit;const select=viewer.querySelector('select');select.replaceChildren();item.variants.forEach((variant,i)=>{const option=document.createElement('option');option.value=String(i);option.textContent=variant.label;select.append(option)});select.hidden=item.variants.length<2;select.onchange=()=>{img.src=item.variants[Number(select.value)].src};grid.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.id===item.id)));if(focus&&matchMedia('(max-width:749px)').matches)viewer.scrollIntoView({block:'start',behavior:'auto'});};
 const render=()=>{const matches=data.records.filter(i=>category==='all'||i.category===category);grid.replaceChildren();matches.slice(0,limit).forEach(item=>{const button=document.createElement('button');button.type='button';button.dataset.id=item.id;button.setAttribute('aria-pressed',String(selected===item.id));button.setAttribute('aria-label',labels.view+' '+title(item));const img=document.createElement('img');img.src=item.variants[0].thumb;img.alt='';img.width=480;img.height=600;img.loading='lazy';const caption=document.createElement('span');caption.textContent=title(item);button.append(img,caption);button.addEventListener('click',()=>choose(item,true));grid.append(button)});count.textContent=Math.min(limit,matches.length)+' / '+matches.length;more.hidden=limit>=matches.length;if(!matches.some(i=>i.id===selected)&&matches.length)choose(matches[0]);};
 filters.forEach(button=>button.addEventListener('click',()=>{category=button.dataset.sfaFilter;limit=12;selected=null;filters.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));render()}));more.addEventListener('click',()=>{limit+=12;render()});render();
 root.querySelectorAll('[data-sfa-strip]').forEach(strip=>{const region=strip.querySelector('.tpl-sfa__look-strip');strip.querySelectorAll('[data-sfa-direction]').forEach(button=>button.addEventListener('click',()=>region.scrollBy({left:Number(button.dataset.sfaDirection)*region.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})))});
 root.querySelectorAll('[data-sfa-pdf]').forEach(details=>details.addEventListener('toggle',()=>{const frame=details.querySelector('iframe');if(details.open&&!frame.getAttribute('src'))frame.src=frame.dataset.src}));
 const anchors=[...root.querySelectorAll('.tpl-sfa__nav a')],chapters=anchors.map(a=>({a,target:root.querySelector(a.hash)})).filter(item=>item.target);let navFrame=0;
 const updateChapter=()=>{navFrame=0;const edge=(parseFloat(getComputedStyle(root).getPropertyValue('--tpl-sticky-height'))||0)+(archiveNav?.offsetHeight||0)+24;let current=null;chapters.forEach(item=>{if(item.target.getBoundingClientRect().top<=edge)current=item.a});anchors.forEach(a=>{if(a===current)a.setAttribute('aria-current','location');else a.removeAttribute('aria-current')});};
 const scheduleChapter=()=>{if(!navFrame)navFrame=requestAnimationFrame(updateChapter)};window.addEventListener('scroll',scheduleChapter,{passive:true});window.addEventListener('resize',scheduleChapter,{passive:true});root.addEventListener('load',scheduleChapter,true);scheduleChapter();
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpl-tailor-champion"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('tpl-archive')){customElements.define('tpl-archive',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.tpl-archive__track'),slides=[...track.children],prev=this.querySelector('[data-archive-prev]'),next=this.querySelector('[data-archive-next]'),count=this.querySelector('.tpl-archive__count');let index=0;const update=()=>{const x=track.scrollLeft;index=slides.reduce((best,slide,i)=>Math.abs(slide.offsetLeft-slides[0].offsetLeft-x)<Math.abs(slides[best].offsetLeft-slides[0].offsetLeft-x)?i:best,0);const atEnd=x>=track.scrollWidth-track.clientWidth-3;count.textContent=String(atEnd?slides.length:index+1).padStart(2,'0')+' / '+slides.length;prev.disabled=x<2;next.disabled=x>=track.scrollWidth-track.clientWidth-3;};const move=delta=>{const target=Math.max(0,Math.min(slides.length-1,index+delta));track.scrollTo({left:slides[target].offsetLeft-slides[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});track.addEventListener('scroll',()=>requestAnimationFrame(update),{passive:true});this.resize=new ResizeObserver(update);this.resize.observe(track);update();}disconnectedCallback(){this.resize?.disconnect();this.ready=false;}});}

  } catch(e) { console.error(e); }
})();
})();
